import { 
  fmtDaysHrsMinFromISODateRange
} from '../../utils/formatters';

export function fmtExecutionDuration(value) {
  var startTime=value.StartTime;
  var endTime=value.EndTime;
  
  if(startTime && endTime) {
    return fmtDaysHrsMinFromISODateRange(endTime,startTime);
  } else {
    return "In Progress";
  }
}
